import { render, staticRenderFns } from "./AlertasFinca.vue?vue&type=template&id=c7b7c694&"
import script from "./AlertasFinca.vue?vue&type=script&lang=js&"
export * from "./AlertasFinca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports